import { Star } from "lucide-react";

export default function StarButton({ starred, onClick, size = "md", testId }) {
  const cls = size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4";
  return (
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); onClick(); }}
      aria-pressed={starred}
      title={starred ? "Unstar" : "Star this catalyst"}
      className={`p-1.5 rounded-md transition-all duration-200 hover:scale-110 active:scale-95 ${starred ? "text-amber-400 drop-shadow-[0_0_6px_rgba(251,191,36,0.6)]" : "text-slate-500 hover:text-amber-300"}`}
      data-testid={testId}
    >
      <Star className={cls} fill={starred ? "currentColor" : "none"} />
    </button>
  );
}
